import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormSection } from "./FormSection";
import { HRadio } from "../../../../validation/HForm";
import MonthlyPaymentSection from "./MonthlyPaymentSecrion";
import { RADIO_NAMES } from "../constants/constants";
import IndustrySection from "./IndustrySection";

const PaymentSection = ({ questionNumber, title, description, radioName }) => {
  const { control } = useFormContext();
  const radioValue = useWatch({ control, name: radioName });
  const showPaymentField = radioValue === "Да";

  return (
    <FormSection
      questionNumber={questionNumber}
      title={title}
      description={description}
    >
      <div className="d-flex columns-2">
        <HRadio
          labels={["Да", "Нет"]}
          name={radioName}
          checkboxStyle={true}
          pillboxStyle={true}
        />
      </div>

      {showPaymentField &&
        (radioName === RADIO_NAMES.IS_WORKING ? (
          <IndustrySection questionNumber={2.1}/>
        ) : (
          <div>
            <MonthlyPaymentSection
              questionNumber={4.1}
              title="Платежи по договорам банков"
              label="Укажите общую сумму ежемесячного платежа по всем таким договорам"
              radioName={RADIO_NAMES.IS_CREDIT_DEBT}
              paymentName="creditDebt"
            />

            <MonthlyPaymentSection
              questionNumber={4.2}
              title="Платежи по договорам лизинга"
              label="Укажите общую сумму ежемесячного платежа по всем таким договорам"
              radioName={RADIO_NAMES.IS_LEASING_DEBT}
              paymentName="leasingDebt"
            />

            <MonthlyPaymentSection
              questionNumber={4.3}
              title="Платежи по договорам займа (микрозайма)"
              label="Укажите общую сумму ежемесячного платежа по всем таким договорам"
              radioName={RADIO_NAMES.IS_MICROLOAN_DEBT}
              paymentName="microloanDebt"
            />

            <MonthlyPaymentSection
              questionNumber={4.4}
              title="Платежи по договорам коммерческого займа, рассрочки/отсрочки платежа"
              label="Укажите общую сумму ежемесячного платежа по всем таким договорам"
              radioName={RADIO_NAMES.IS_GOODS_DEBT}
              paymentName="goodsDebt"
            />

            <MonthlyPaymentSection
              questionNumber={4.5}
              title="Наличие просроченной задолженности по вышеперечисленным обязательствам"
              label="Укажите сумму просроченной задолженности на данный момент"
              radioName={RADIO_NAMES.IS_EXPIRE_DEBT}
              paymentName="expireDebt"
            />

            <MonthlyPaymentSection
              questionNumber={4.6}
              title="Наличие просроченных платежей по обязательствам, обеспеченных поручительством клиента"
              label="Укажите сумму таких ежемесячных платежей"
              radioName={RADIO_NAMES.IS_GUARANTEE_AGREEMENTS}
              paymentName="guaranteeAgreementDebt"
            />
        
            <MonthlyPaymentSection
              questionNumber={4.7}
              title="Наличие иных ежемесячных платежей"
              label="Укажите сумму таких ежемесячных платежей"
              radioName={RADIO_NAMES.IS_OTHER_DEBT}
              paymentName="otherDebt"
            />
          </div>
        ))}
    </FormSection>
  );
};

export default PaymentSection;
